import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Alert
} from '@mui/material';
import { useAuth } from '../../components/auth/AuthContext';
import AdminTabs from '../../components/admin/AdminTabs';
import Conferences from '../../components/admin/Conferences';

export default function ConferencesPage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);

  const isAuthenticated = currentUser && (currentUser.userType === 'internal' || currentUser.userType === 'admin');

  useEffect(() => {
    if (isAuthenticated) {
      // User is authenticated with admin privileges
    } 
    setLoading(false);
  }, [navigate, isAuthenticated]);

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Alert severity="warning">
          Please log in to access this page.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', py: 4, mt: 8 }}>
      <Container maxWidth="lg">

        <AdminTabs currentPath="/admin/conferences" />
        
        <Box sx={{ mt: 3 }}>
          <Conferences />
        </Box>
      </Container>
    </Box>
  );
}